import React from 'react';
import { useSelector } from 'react-redux';

import ExitConfirmation from 'components/ExitConfirmation';

import { selectIsError } from './selectors';

export const TimesheetExitConfirmation = (): React.ReactElement => {
    const isError = useSelector(selectIsError);

    return (
        <ExitConfirmation
            message="There are unsaved entries, data may be lost if you leave this page"
            when={isError}
            onlyPathname
        />
    );
};

export default React.memo(TimesheetExitConfirmation);
